export default __webpack_public_path__ + "static/media/114_krikkrok.61d6bdb7.webp";